/* eslint-disable node/no-unsupported-features/es-syntax */
import { STORE_ROUTE_NAMES } from "@/shared";
export const STORE_ROUTES = [
    {
        name: STORE_ROUTE_NAMES.PRODUCT.MAIN,
        path: "/store/product",
        meta: {
            title: "words.goods_section",
        },
        component: () => import("../ui/ProductsPage.vue"),
    },
    {
        name: STORE_ROUTE_NAMES.PRODUCT.ADD,
        path: "/store/product/add",
        meta: {
            title: "words.add_product",
        },
        component: () => import("../ui/ProductsEdit.vue"),
    },
    {
        name: STORE_ROUTE_NAMES.PRODUCT.EDIT,
        path: "/store/product/edit/:id",
        meta: {
            title: "words.edit_product",
        },
        component: () => import("../ui/ProductsEdit.vue"),
        props: true,
    },
    {
        name: STORE_ROUTE_NAMES.STOCK.MAIN,
        path: "/store",
        meta: {
            title: "words.goods_section",
        },
        component: () => import("../ui/StorePage.vue"),
    },
    {
        name: STORE_ROUTE_NAMES.STOCK.ADD,
        path: "/store/add",
        meta: {
            title: "words.add_product",
        },
        component: () => import("../ui/StoreEdit.vue"),
    },
    {
        name: STORE_ROUTE_NAMES.STOCK.EDIT,
        path: "/store/edit/:id",
        meta: {
            title: "words.edit_product",
        },
        component: () => import("../ui/StoreEdit.vue"),
        props: true,
    },
];
